/**
 * IntelliGems A/B Test: Best seller tag
 *
 * Control (A): data-best-seller-tag="false"
 * Variant (B): data-best-seller-tag="true"
 *
 * Dev preview: ?best_seller_tag_test=b
 */
(function () {
  'use strict';

  if (window.__bestSellerTagABTestInit) return;
  window.__bestSellerTagABTestInit = true;

  var BODY_ATTR = 'data-best-seller-tag';
  var applying = false;
  var debounceTimer = null;
  var variantActive = null;

  function isDevVariantB() {
    try {
      return new URLSearchParams(window.location.search).get('best_seller_tag_test') === 'b';
    } catch (e) {
      return false;
    }
  }

  function isVariantB() {
    if (isDevVariantB()) return true;

    var body = document.body;
    var html = document.documentElement;
    if (!body || !html) return false;

    return body.getAttribute(BODY_ATTR) === 'true' ||
      html.getAttribute(BODY_ATTR) === 'true';
  }

  function applyVariant() {
    if (applying) return;
    applying = true;

    try {
      var variantB = isVariantB();
      if (variantB === variantActive) return;

      variantActive = variantB;
      document.documentElement.classList.toggle('best-seller-tag-b', variantB);
    } finally {
      applying = false;
    }
  }

  function scheduleApply() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyVariant, 40);
  }

  function init() {
    if (isDevVariantB()) {
      if (document.documentElement.getAttribute(BODY_ATTR) !== 'true') {
        document.documentElement.setAttribute(BODY_ATTR, 'true');
      }
      if (document.body && document.body.getAttribute(BODY_ATTR) !== 'true') {
        document.body.setAttribute(BODY_ATTR, 'true');
      }
    }

    applyVariant();

    if (!document.body) return;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === BODY_ATTR ||
          mutations[i].attributeName === 'data-gem-variant' ||
          mutations[i].attributeName === 'data-gem-test-active') {
          scheduleApply();
          return;
        }
      }
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [BODY_ATTR, 'data-gem-variant', 'data-gem-test-active']
    });

    document.addEventListener('gem:variant:changed', scheduleApply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
